/** Norske etiketter for lead-status og utfall (felles for listetabell, kort og statistikk). */
export const LEAD_STATUS_LABELS: Record<string, string> = {
  open: "Åpen",
  locked: "Låst",
  in_pipe: "I pipe",
  customer: "Kunde",
  parked: "Parkert",
  irrelevant: "Avvist",
};
